import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledMoreSVG = styled.svg<IconProps>`
  & .cls-1 {
    fill: #fff;
    opacity: 0;
  }

  .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &.hover:hover,
  &.active {
    .cls-2 {
      fill: var(--du-color-primary, #128370);
      stroke: var(--du-color-primary, #128370);
      stroke-miterlimit: 10;
    }
  }
`;

const MoreIcon: React.FC<IconProps> = ({ active }) => {
  let activeClass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledMoreSVG
      id='More-Icon-SVG'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
    >
      <path
        id='Rectangle_675'
        data-name='Rectangle 675'
        className='cls-1'
        d='M2,0H30a2,2,0,0,1,2,2V32a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z'
      />
      <g id='Menu_Icon' data-name='Menu Icon' transform='translate(14.5 8.5)'>
        <circle id='Ellipse_49' data-name='Ellipse 49' className='cls-2' cx='1.5' cy='1.5' r='1.5' />
        <circle
          id='Ellipse_50'
          data-name='Ellipse 50'
          className='cls-2'
          cx='1.5'
          cy='1.5'
          r='1.5'
          transform='translate(0 6)'
        />
        <circle
          id='Ellipse_51'
          data-name='Ellipse 51'
          className='cls-2'
          cx='1.5'
          cy='1.5'
          r='1.5'
          transform='translate(0 12)'
        />
      </g>
    </StyledMoreSVG>
  );
};

export default MoreIcon;
